/* eslint-disable */
import { DqlModel } from '../dql/dql.model';
import { Map } from 'immutable';

/* eslint-enable */

export class StockIntakeHeaderDqlFieldTextProvider {
  public static getHelper(): DqlModel.DqlStaticFieldTextHelper {
    const fields: Map<string, DqlModel.DqlFieldTexts> = Map.of(
      'id', {stringKey: 'COMMON_TABLE_HEADER_ID'},
      'invoice_number', {stringKey: 'FORM_RECORD_STOCK_INTAKE_HEADER_INVOICE_NUMBER'},
      'shipping_number', {stringKey: 'FORM_RECORD_STOCK_INTAKE_HEADER_SHIPPING_NUMBER'},
      'shipping_company', {stringKey: 'FORM_RECORD_STOCK_INTAKE_HEADER_LEGACY_SHIPPING_COMPANY'},
      'supplier_company_id', {stringKey: 'FORM_RECORD_STOCK_INTAKE_HEADER_SHIPPING_COMPANY'},
      'intake_date', {stringKey: 'STOCK_RECORD_LOT_INTAKE_DATE'},
    );
    return new DqlModel.DqlStaticFieldTextHelper(fields);
  }
}
